export { links, loader, meta, default } from "./$themeId.$themeName";
